import script from "./headCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./headCard.vue?vue&type=script&setup=true&lang=ts"

import "./headCard.vue?vue&type=style&index=0&id=28518556&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28518556"]])

export default __exports__